import React, { useState } from 'react'
import crosssimgiocn from "../../src/Images/crosssimgiocn.png";
import vectorarrow from "../../src/Images/vectorarrow.png"
import HttpClient from '../utils/HttpClient';
import toast, { useToaster } from 'react-hot-toast';
const PostEnqueyModal = ({ closemodal, post }) => {
    const [drowdowsncustom, setDrowdowsncustom] = useState(false)
    const drowdowncustclick = () => {
        setDrowdowsncustom(!drowdowsncustom)
    }

    const initialData = {
        postId: post,
        name: "",
        workEmail: "",
        mobile: "",
        typeOfEnquiry: "",
        enquirySubject: "",
        enquiry: "",
        file: ""
    }
    const [formData, setFormData] = useState(initialData);
    const __updateForm = (name, value) => {

        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    ////////////////Word Limit
    const maxWords = 60;

    const updateForm = (key, value) => {
        const words = value.trim().split(/\s+/).filter(Boolean);
        if (key === "enquiry") {
            if (words.length <= maxWords) {
                setFormData({ ...formData, [key]: value });
            }
        } else {
            setFormData({ ...formData, [key]: value });
        }
    }

    const wordCount = formData.enquiry.trim().split(/\s+/).filter(Boolean).length;
    const wordsRemaining = maxWords - wordCount;

    const [fileName, setFileName] = useState("");
    const [uploadedFilePath, setUploadedFilePath] = useState("")
    const [attachmentUploading, setAttachmentUploading] = useState(false)

    const imageUpload = async (file) => {
        if (!file) return; // Ensure there is a file to upload

        setAttachmentUploading(true);
        const formData = new FormData();
        formData.append("image", file);

        try {
            // const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            const res = await HttpClient.fileUploadWithoutAuth("image-upload", "POST", formData);
            if (res.status) {
                // setData(res.data.url);
                updateForm("file", res.data.url)
                // setUploadedFilePath(res.data.url)
                // setHasData(true);
            } else {
                console.log("Error while uploading image");
            }
        } catch (error) {
            console.error("Upload failed:", error);
        } finally {
            // updateForm("file", res.data.url)
            setAttachmentUploading(false);
        }
    };
    const [uploadedFilePreview, setUploadedFilePreview] = useState("No file chosen")
    const handleFileChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            setFileName(event.target.files[0].name);
            // setUploadedFilePreview(event.target.files[0].name.split('.').pop().toLowerCase())
            setUploadedFilePreview(event.target.files[0].name)
            imageUpload(event.target.files[0]);
        } else {
            // setFileName("No file chosen");
            setUploadedFilePreview("No file chosen")
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = {
            ...formData
            // file: uploadedFilePath,
        }

        try {
            const response = await HttpClient.requestData(
                "business-post-enquiry",
                "POST",
                data
            );
            if (response.status) {
                // Navigate to payment page
                // Navigate("/searchhome");
                // Navigate("/");
                // dispatch(getOwnProfile())

                // closemodal()
                toast.success(<>Enquiry sent successfully</>)

            } else {
                console.error("Error in Post");
            }
        } catch (error) {
            console.error("Error submitting Post:", error);
        } finally {
            // dispatch(fetchMyBusinessPosts())
            closemodal()
        }
    }

    const [ddlTypeOfEnquery, setDdlTypeOfEnquery] = useState(false)
    const ddlTypeOfEnqueryClick = () => {
        setDdlTypeOfEnquery(!ddlTypeOfEnquery)
    }

    const typeOfEnquery = [
        {
            name: "Buy/Sell",
            _id: "1"
        },
        {
            name: "Publish",
            _id: "2"
        }
    ]

    return (
        <div className='otherprofudvtmodalbackbox'>
            <div className='enquerysmokdnndbndbg'>
                <div className="threedorttsdcoroodivflx">
                    <div className="imnmnprhhhsbdijnvvgbsj" onClick={() => closemodal()} style={{cursor:"pointer"}}>
                        <img src={crosssimgiocn} alt="..." />
                    </div>
                </div>

                <div className="psendwendijndwjjwndiv">
                    <p className="breyuuayproosttxppp">Send Enquery</p>
                    <div className='compamydinfodivmainbtmhuhauhdsicflx'>
                        <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>First Name <span> * </span></p>
                            <input type="text" placeholder="john" className="inpustxocntbusuitxtppnewallattyy"
                                value={formData.name || ""}
                                onChange={(e) => updateForm("name", e.target.value)}
                            />
                        </div>

                        <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Mobile number  <span> * </span></p>
                            <input type="number" placeholder="9173459034" className="inpustxocntbusuitxtppnewallattyy"
                                value={formData.mobile || ""}
                                onChange={(e) => updateForm("mobile", e.target.value)}
                            />
                        </div>

                        <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Work email <span> * </span></p>
                            <input type="text" placeholder="info@companyname.com" className="inpustxocntbusuitxtppnewallattyy"
                                value={formData.workEmail || ""}
                                onChange={(e) => updateForm("workEmail", e.target.value)}
                            />
                        </div>

                        {/* <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Type of enquiry <span> * </span></p>
                            <div className='dropwdowndivfrmbusineenewwlas'>
                                <p className='vectoraarowdivomgulmaili'>
                                    Buy/Sell
                                </p>
                                <div className='vectoraarowdivomgnenwlal' onClick={drowdowncustclick}>
                                    <img src={vectorarrow} alt='...' />
                                </div>
                                {drowdowsncustom && <div className='vectoraarowdivomgulmai'>
                                    <ul className='vectoraarowdivomgulmaiul'>
                                        <li className='vectoraarowdivomgulmaili'>
                                            Buy/Sell
                                        </li>
                                    </ul>
                                </div>}
                            </div>
                        </div> */}

                        <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Type of enquiry <span> * </span></p>
                            <div className='dropwdowndivfrmbusineenewwlas'>
                                {
                                    formData.typeOfEnquiry ? (
                                        <p className='vectoraarowdivomgulmaili'>
                                            {formData.typeOfEnquiry}
                                        </p>
                                    ) : (
                                        <p className='vectoraarowdivomgulmaili'>
                                            --- Choose ---
                                        </p>
                                    )
                                }

                                <div className='vectoraarowdivomgnenwlal' onClick={ddlTypeOfEnqueryClick}>
                                    <img src={vectorarrow} alt='...' />
                                </div>
                                {ddlTypeOfEnquery && <div className='vectoraarowdivomgulmai'>
                                    <ul className='vectoraarowdivomgulmaiul'>
                                        {typeOfEnquery.map((type, index) => (
                                            <li
                                                key={index}
                                                className="vectoraarowdivomgulmaili"
                                                onClick={(e) => {
                                                    // handleInputChange("state", state);
                                                    // toggleDropdown("state");
                                                    updateForm("typeOfEnquiry", type?.name)
                                                    ddlTypeOfEnqueryClick()
                                                }}
                                            >
                                                {type?.name}
                                            </li>
                                        ))}
                                    </ul>
                                </div>}
                            </div>
                        </div>

                        <div className='_compamydinfodivmdiobbdgppshg compamydinfodivtesxtrareobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Enquiry subject <span> * </span></p>
                            <input type="text" placeholder="Enter a subject" className="inpustxocntbusuitxtppnewallattyy"
                                value={formData.enquirySubject || ""}
                                onChange={(e) => updateForm("enquirySubject", e.target.value)}
                            />
                        </div>

                        <div className='compamydinfodivtesxtrareobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Enquiry message <span> * </span></p>
                            {/* <textarea rows={4} cols={4} className='ennsjjuwtysttsxttaytredg'
                                value={formData.enquiry || ""}
                                onChange={(e) => updateForm("enquiry", e.target.value)}
                            /> */}

                            <textarea
                                rows={4}
                                cols={4}
                                className="ennsjjuwtysttsxttaytredg"
                                placeholder="Enter your message..."
                                value={formData.enquiry}
                                onChange={(e) => updateForm("enquiry", e.target.value)}
                            />
                            {/* <p style={{ fontSize: '13px', float: "right", color: wordsRemaining === 0 ? 'red' : 'gray' }}>
                            {wordsRemaining} word{wordsRemaining !== 1 ? 's' : ''} remaining
                        </p> */}
                            <p style={{ fontSize: '13px', float: "right", color: wordsRemaining === 0 ? 'red' : 'gray' }}>
                                ({wordsRemaining} - 60)
                            </p>



                        </div>



                        {/* <div className='compamydinfodivtesxtrareobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Attachment <span>  </span></p>
                            <div className='chossefilkklkebdtrfdiv'>
                                <div className='enuqteyschosefllfbrdttdivdkdlnb'>


                                    <button className='enuqteyschosefllfbrdtt'>
                                        Choose file
                                    </button>
                                    <p>No file chosen</p>
                                </div>
                            </div>
                            <p className='alkoowjdiisdttxpp'>Allowed file types: JPG, PNG, PDF, Maximum allowed size is 2 MP</p>

                        </div> */}

                        <div className='poysttdiobnnnmmmnjm'>
                            <p className='conattaindptxtppnewallasa'>Attachment <span>  </span></p>
                            <div className='chossefilkklkebdtrfdiv'>
                                <div className='enuqteyschosefllfbrdttdivdkdlnb'>
                                    <div className="custom-file-upload">
                                        <label for="file-upload" className="file-label">
                                            Choose file
                                        </label>
                                        <input id="file-upload" type="file" onChange={handleFileChange} />
                                        {/* <span id="file-chosen">{fileName}</span> */}
                                        <span id="file-chosen">{uploadedFilePreview}</span>
                                        {attachmentUploading ? <><span>Uploading...</span></> : formData?.file && <><img src={formData?.file} style={{ height: "72px" }} /></>}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div className="svavtatvvbtnnmdivmaokin">
                        <button className="svavtatvvbtnnmsendferdgf"
                            onClick={(e) => handleSubmit(e)}
                        >Send enquiry</button>
                    </div>
                </div>



            </div>
        </div>
    )
}

export default PostEnqueyModal
